export const NEW_CARD = 'new_card'
export const UNDO = 'undo'
export const COPY = 'copy'
export const PASTE = 'paste'
export const SELECT_ALL = 'select_all'
export const CHANGE_COLOR = 'change_color'
export const CLEAR_SELECTED = 'clear_selected'
export const REMOVE_SELECTED = 'remove_selected'
export const MOVE_SELECTED = 'move_selected'
export const COLOR_MARKER = 'color_marker'
export const CLEAR_MARKER = 'clear_marker'
export const MOVE_MARKER = 'move_marker'
export const CREATE_MARKER = 'create_marker'
export const UNKNOWN = 'unknown'
